import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { toolkitColors } from "@/utils/constants";

const Testimonial = dynamic(async () => {
  return (await import("./Testimonial")).default;
});

const isDemo = 1;

Builder.registerComponent(Testimonial, {
  name: "testimonialsCarousel",
  inputs: [
    {
      name: "Testimonial",
      type: "list",
      subFields: [
        {
            name: "showImage",
            type: "boolean",
            default: false,
            helperText:
              "Choose whether to display an image or background color",
        },
        {
            name: "image",
            type: "file",
            allowedFileTypes: ["jpeg", "png"],
            helperText:
              "You can upload a file type that is either JPEG or PNG",
            showIf: `options.get('showImage') == true`,
            required: true,
        },
        {
            name: "backgroundColor",
            type: "string",
            defaultValue: "Oat",
            enum: toolkitColors,
            helperText:
              "Choose background color",
            showIf: `!options.get('showImage') || options.get('showImage') == false`,
            required: true,
        },
        {
            name: "body",
            type: "longText",
            defaultValue: "Builder is the first and only headless CMS with a powerful drag-and-drop visual editor that lets you build, optimize, and measure digital experiences with speed and flexibility",
            helperText:
              "Enter testimonial body",
            onChange: `if(options.get("body").length > 160) {options.set("body", options.get("body").slice(0, 160));alert("Maximum number of characters is 160")}`,
            required: true,
        },
        {
            name: "SpeakerName",
            type: "string",
            defaultValue: "",
            helperText:
              "Enter testimonial body",
            onChange: `if(options.get("SpeakerName").length > 55) {options.set("SpeakerName", options.get("SpeakerName").slice(0, 55));alert("Maximum number of characters is 55")}`,
            required: true,
        },
        {
            name: "CTAText",
            type: "string",
            defaultValue: "Click me",
            helperText: "Text that will be displayed for this CTA",           
            onChange: `if(options.get("CTAText").length > 30) {options.set("CTAText", options.get("CTAText").slice(0, 30));alert("Maximum number of characters is 30")}`,
        },
        {
          name: "CTAUrl",
          type: "url",
        },
        {
            name: "icon",
            type: "file",
            allowedFileTypes: ["jpeg", "png"],
            helperText:
              "You can upload a file type that is either JPEG or PNG",
        }
      ]
    }
  ],
});
